import React from 'react';
import { connect } from 'react-redux';
import { guardarContrasena } from './servicios.act'

const mapDispatch = (dispatch) => {
    return {
        pasoSiguiente: () => {
            dispatch({ "type": "MODIFICAR_PASO_SIGUIENTE" });
        },
        setContrasena: (contrasena) => {
            dispatch({ "type": "MODIFICAR_SET_CONTRASENA", "contrasena": contrasena});
        }
    }
}

class IngresaCorreo extends React.Component {
    state = {
        inputTypeContrasena: "password",
        inputTypeConfirmar: "password",
        inputClassContrasena: "input-label ver-input mt-70",
        inputClassConfirmar: "input-label ver-input mt-70",
        inputActiveContrasena: "",
        inputActiveConfirmar: "",
        errorContrasena: false,
        errorConfirmar: false,
        errorMsjContrasena: "",
        errorMsjConfirmar: "",
        contrasena: "",
        confirmar: ""
    }

    changeInputType = (event) => {
        let flag = event.target.id;
        let type;
        switch(flag) {
            case "ojo-1":
                type = this.state.inputTypeContrasena;
                this.setState({inputTypeContrasena: type == 'password' ? 'text' : 'password'});
                this.setState({inputClassContrasena: type == 'password' ? 'input-label visible-input mt-70' : 'input-label ver-input mt-70'});
                break;
            case "ojo-2":
                type = this.state.inputTypeConfirmar;
                this.setState({inputTypeConfirmar: type == 'password' ? 'text' : 'password'});
                this.setState({inputClassConfirmar: type == 'password' ? 'input-label visible-input mt-70' : 'input-label ver-input mt-70'});
                break;
        }
    }
    blurHandler = (event) => {
        let flag = event.target.id;
        let valor = event.target.value;
        switch(flag) {
            case "input-1":
                this.setState({contrasena: valor});
                this.setState({inputActiveContrasena: valor ? "input-active" : ""});
                break;
            case "input-2":
                this.setState({confirmar: valor});
                this.setState({inputActiveConfirmar: valor ? "input-active" : ""});
                break;
        }
    }
    focusHandler = (event) => {
        let flag = event.target.id;
        switch(flag) {
            case "input-1":
                this.setState({inputActiveContrasena: "input-active"});
                this.setState({errorMsjContrasena: ""});
                event.target.value = this.state.errorContrasena ? "" : event.target.value;
                this.setState({errorContrasena: false});
                break;
            case "input-2":
                this.setState({inputActiveConfirmar: "input-active"});
                this.setState({errorMsjConfirmar: ""});
                event.target.value = this.state.errorConfirmar ? "" : event.target.value;
                this.setState({errorConfirmar: false});
                break;
        }
    }
    guardarContrasena = () => {
        let contrasena = this.state.contrasena;
        let confirmar = this.state.confirmar;
        this.setState({errorConfirmar: false});
        this.setState({errorMsjConfirmar: ""});
        if(!contrasena) {
            this.setState({errorContrasena: true});
            this.setState({errorMsjContrasena: "Campo requerido."});
            return;
        }
        if(!confirmar) {
            this.setState({errorConfirmar: true});
            this.setState({errorMsjConfirmar: "Campo requerido."});
            return;
        }
        if(contrasena != confirmar) {
            this.setState({errorConfirmar: true});
            this.setState({errorMsjConfirmar: "Las contraseñas no coinciden. Favor de validar."});
            return;
        } else {
            guardarContrasena({contrasena: contrasena, confirmacion: confirmar}).then((response) => response.json()).then((responseJson) => {
                if(responseJson.success) {
                    this.props.pasoSiguiente();
                } else {
                    let texto = "Tu contraseña: ";
                    for (var i = 0; i < responseJson.errores.length; i++) {
                        switch(responseJson.errores[i]) {
                            case 1:
                                texto += ", ";
                                break;
                            case 2:
                                texto += "debe ser de 8 posiciones, incluyendo caracteres alfanuméricos, ";
                                break;
                            case 3:
                                texto += ", ";
                                break;
                            case 4:
                                texto += "no coincide con la confirmación, ";
                                break;
                            case 5:
                                texto += "no debe contener la palabra GNP, ";
                                break;
                            case 6:
                                texto += "no debe contener más de dos caracteres iguales de manera consecutiva (p.e. 222, eee), ";
                                break;
                            case 7:
                                texto += "no debe tener más de dos caracteres consecutivos numéricos o alfabéticos (p.e. 123, abc), ";
                                break;
                        }
                    };
                    texto = texto.substring(0, texto.length - 2);
                    this.setState({errorMsjConfirmar: texto});
                    this.setState({errorConfirmar: true});
                }
            });
        }
    }

    render() {
        return <div className="login-form">
            <div className="text-center">
                <a href="" className="pull-left">
                    <img src={ require("../img/arrow-back.png") } alt="" />
                </a>
                <img src={ require("../img/logo-gnp.svg") } alt="" />
            </div>
            <h3>Modificar contraseña</h3>
            <div className="text-content mt-70">
                <div className="datos-wrap row">
                    <div className="col-xs-12">
                        <h5>
                            <i>
                                <img src={ require("../img/icon-password.png") } alt="" />
                            </i>Restablecer contraseña
                            <span className="orange-tooltip">
                                <button type="button" className="btn btn-primary btn-lg" data-toggle="modal" data-target="#modal-contrasena">
                                    <img src={ require("../img/icon_information.png") } alt="" />
                                </button>
                            </span>
                        </h5>
                    </div>
                    <div className="col-xs-12">
                        <div className="row mt-25">
                            <div className="col-xs-12">
                                <div className={this.state.inputClassContrasena}>
                                    <label>Nueva contraseña</label>
                                    <span className={this.state.inputActiveContrasena}>
                                        <input id="input-1" type={this.state.inputTypeContrasena} onFocus={this.focusHandler} onBlur={this.blurHandler} />
                                    </span>
                                    { this.state.errorContrasena &&
                                        <div className="error-wrap">
                                            <div className="msj-error">
                                                <p>{this.state.errorMsjContrasena}</p>
                                            </div>
                                        </div>
                                    }
                                    <button className="btn-ojo" id="ojo-1" onClick={this.changeInputType}>
                                        <i></i>
                                    </button>
                                </div>
                            </div>
                            <div className="col-xs-12">
                                <div className={this.state.inputClassConfirmar}>
                                    <label>Confirmar nueva contraseña</label>
                                    <span className={this.state.inputActiveConfirmar}>
                                        <input id="input-2" type={this.state.inputTypeConfirmar} onFocus={this.focusHandler} onBlur={this.blurHandler} />
                                    </span>
                                    { this.state.errorConfirmar &&
                                        <div className="error-wrap">
                                            <div className="msj-error">
                                                <p>{this.state.errorMsjConfirmar}</p>
                                            </div>
                                        </div>
                                    }
                                    <button className="btn-ojo" id="ojo-2" onClick={this.changeInputType}>
                                        <i></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <a onClick={this.guardarContrasena}>
                    <button className="orange-circle">
                        <i></i>
                    </button>
                </a>
            </div>
            <div className="modal fade" id="modal-contrasena" tabIndex="-1" role="dialog" aria-labelledby="modal-contrasenaLabel">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="modal-contrasenaLabel">Nota</h4>
                        </div>
                        <div className="modal-body">
                            <p className="blue-text">Establece tu contraseña con las siguientes características:</p>

                            <p>- Debe ser de 8 posiciones, incluyendo caracteres alfanuméricos.</p>
                            <p>- No debe contener la palabra GNP.</p>
                            <p>- No debe contener más de dos caracteres iguales de manera consecutiva (p.e. 222, eee).</p>
                            <p>- No debe tener más de dos caracteres consecutivos numéricos o alfabéticos (p.e. 123, abc).</p>
                            <p>- Debe incluir al menos una letra mayúscula, una letra minúscula y un número.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn orange-btn" data-dismiss="modal">Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	}
}

export default connect(null, mapDispatch)(IngresaCorreo);



// WEBPACK FOOTER //
// ./src/modificar/reestablecer.cmpt.js